import React, { Component, useContext } from "react";

import { notification } from "antd";
import { BaseContext } from "../BaseContext";

const LogOut = () => {
  const { setToken, setUser, setEmail } = useContext(BaseContext);


  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Logout Success",
      description: "Logout successful  ",
    });
  };

  const onOut = () => {
    setToken("");
    setUser("");
    setEmail("");
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("email");
    openNotificationWithIcon("info");
  };

  return (
    <>
      <span onClick={onOut} title="Logout">
        Log Out
      </span>
    </>
  );
};

export default LogOut;
